module.exports = __webpack_public_path__ + "img/swiper7.f8bfbeeb.png";